<template>
	<div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''" style="padding-top: 72px">
		<head-nav></head-nav>
		<div class="feedback_body">
			<div id="downBox" class="zhanwei" name="downBox"></div>
			<div class="title">产品问题反馈</div>
			<el-form ref="form" class="feedback_content" :rules="rules" :model="formData" label-width="112px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="反馈内容：" prop="contenttxt">
							<!-- <vue-ueditor-wrap ref="ueditor" v-model="formData.content" :config="configEditor">
							</vue-ueditor-wrap> -->
							<div class="placeholder" id="isplaceholder">请尽量详细描述您遇到的问题或建议，可直接粘贴截图</div>
							<div id="content_img" ref="content_img" class="content_img" contentEditable="true"
								@input="changeAnswerContent">
							</div>
							<div class="tips_box">
								<div class="tips_txt" v-if="isTips">最多允许输入300个字符</div>
								<div class="num_txt"><span id="num_txt">{{ num }}</span>/300</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="">
							<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
								@files-submitted="onSubmitted" class="uploader-app">
								<uploader-unsupport></uploader-unsupport>
								<uploader-btn id="global-uploader-btn" class="uploader-btn btn el-button--primary"
									:attrs="attrs" ref="uploadBtn">添加附件</uploader-btn>
							</uploader>
							<div class="upload_list" v-if="fileList.length > 0">
								<ul>
									<li v-for="(item, index) in fileList" :key="index">
										<span class="icon"></span>
										<a :title="item.name">{{ item.name | limitFileName(25) }}</a>
										<span style="width:100px">
											{{ item.loading ? '上传中' : (item.success ? '上传成功' : '上传失败') }}
											<span class="slh" v-if="item.loading">...</span>
										</span>
										<div class="icon_del" @click="delBtn(index)" v-if="!item.loading"></div>
									</li>
								</ul>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="联系方式：">
							<el-input v-model="formData.tel" placeholder="建议留下邮箱或QQ等，以便我们为您服务" maxlength="50" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center" class="btn_box">
					<el-col :span="4" align="center">
						<el-button type="primary" @click="submitForm('form')" id="checkBtn"
							style="opacity:.5;cursor: not-allowed;" :loading="!isSubmit">提交反馈</el-button>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="19" align="center">
						<div class="tips">数科OFD将收集一些您的设备信息，以便更好地定位问题。我们将严格保护您的隐私。<br />
							提交反馈代表您接受<span @click="jump">《数科OFD版式软件PC客户端隐私政策》</span></div>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<customer-service></customer-service>
		<!-- 提示弹框 -->
		<el-dialog title="提示" :visible.sync="dialogFolder" class="changephone_box fail_box"
			:close-on-click-modal="false" width="420px" append-to-body :before-close="submitFolder">
			<div class="content">
				<h2>以下{{ gsErrorList.length }}个文件添加失败！</h2>
				<div class="item_list" v-if="gsErrorList.length > 0">
					<h3>文件格式不匹配：</h3>
					<p v-for="(item, index) in gsErrorList" :key="index">
						<a :title="item.name">{{ item.name | limitFileName(20) }}</a>
					</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFolder" size="mini">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="dialogTipsFolder" class="changephone_box" :close-on-click-modal="false"
			width="420px" append-to-body :before-close="closedTipsBtn">
			<div class="title" v-if="isSucess"><img
					src="@comm/images/document-conversion/feedback/seccess_icon.png" />提交成功</div>
			<div class="title" v-if="isError"><img src="@comm/images/document-conversion/feedback/error_icon.png" />提交失败
			</div>
			<div class="msg">{{ msg }}</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitTipsFolder" size="mini" v-if="isGs || isIntenet">
					{{ isIntenet ? '重试' : '确 定' }}</el-button>
				<el-button @click="closedTipsBtn" size="mini" v-if="!isGs">{{ isIntenet ? '返 回' : '关 闭' }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
import { uploadfiles, saveEnclosureInfo } from "@comm/api/document-conversion";
import { getToken } from "@comm/utils/auth";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import common from '@comm/utils/common'
export default {
	components: { footerNav, customerService, headNav },
	name: "index",
	data() {
		return {
			isPhone: false,
			formData: {
				content: '',
				tel: ''
			},
			loading: false,
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { },
			},
			attrs: {
				accept: ACCEPT_CONFIG.getVideo(),
			},

			rules: {
				contenttxt: [
					{
						required: true,
						message: "请输入反馈内容",
						trigger: "blur",
					},
				],
			},
			allUpLoadIng: false,
			fileList: [],
			gsErrorList: [],
			dialogFolder: false,
			code: null,
			dialogTipsFolder: false,
			isGs: false,
			msg: '',
			isSucess: false,
			isError: false,
			isIntenet: false,
			isTips: false,
			isSubmit: true,
			fileIdList: [],
			num: 0
		};
	},
	created() {
		document.title = "产品问题反馈";

		this.code = this.$route.query.feedbackcode ? this.$route.query.feedbackcode : null;
	},
	mounted() {
		this.num = 0;
		document.getElementById('isplaceholder').style.display = 'black'
		var code = this.code
		document.getElementById('content_img').addEventListener('paste', function (e) {
			const selection = window.getSelection();

			if (!(e.clipboardData && e.clipboardData.items)) {
				return;
			}
			selection.deleteFromDocument();
			for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
				var item = e.clipboardData.items[i];
				if (item.kind === "file") {
					var blob = item.getAsFile();
					if (blob.size === 0) {
						return;
					}
					var data = new FormData();
					data.append("code", code);
					data.append("multipartFile", blob);
					uploadfiles(data).then((res) => {

						if (res.code == 0) {
							let fragment = selection.getRangeAt(0).createContextualFragment(`<img src=${res.data.minioUrl} />`);
							selection.getRangeAt(0).insertNode(fragment.lastChild);
						}
					})

					//阻止默认行为即不让剪贴板内容在div中显示出来
					e.preventDefault();
				}
			}
		});
		// 选择目标节点
		const targetNode = document.getElementById('content_img');

		// 创建一个观察者对象
		const observer = new MutationObserver(function (mutationsList, observer) {
			// 对变化进行处理
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					if (!document.getElementById('content_img').innerHTML) {
						document.getElementById('checkBtn').style.opacity = .5
						document.getElementById('checkBtn').style.cursor = 'not-allowed'
						this.num = 0;
						// document.getElementById('isplaceholder').style.display='black'
					} else {
						document.getElementById('checkBtn').style.opacity = 1
						document.getElementById('checkBtn').style.cursor = 'pointer'
						document.getElementById('isplaceholder').style.display = 'none'
						let content = document.getElementById('content_img').innerHTML.replace(/<[^>]+>/g, '')
						this.num = content.length
					}
				}
			}
		});

		// 观察者的配置（观察目标节点的子节点的变化）
		const config = { attributes: true, childList: true, subtree: true, characterData: true };

		// 传入目标节点和观察选项并开始观察
		observer.observe(targetNode, config);
	},
	watch: {
	},
	computed: {
	},
	methods: {
		jump(){
			window.open(`${common.readCodeUrl}/privacy/#/pcprivacy`, "_blank");
		},
		changeAnswerContent(event) {
			this.num = document.getElementById('content_img').innerText.length
			// let textareaContent = event.target.innerText.trim()
			if (this.num < 1) {
				document.getElementById('isplaceholder').style.display = 'block'
			 }else if (this.num > 300) {
				this.isTips = true

				//    textareaContent = textareaContent.slice(0, 10)
				//    // 截取前200个赋值给当前文本框
				// this.$refs.content_img.innerText = textareaContent

				// 将光标重新定位到内容最后
				this.$nextTick(() => {
					this.keepCursorEnd(event.target)
				})
			} else {
				this.isTips = false
			}
		},
		// 将光标重新定位到内容最后
		keepCursorEnd(obj) {
			// ie11 10 9 firefox safari
			if (window.getSelection) {
				// 解决firefox不获取焦点无法定位问题
				obj.focus()

				// 创建range
				let range = window.getSelection()

				// range 选择obj下所有子内容
				range.selectAllChildren(obj)

				// 光标移至最后
				range.collapseToEnd()
			} else if (document.selection) { //ie10 9 8 7 6 5
				// 创建选择对象
				let range = document.selection.createRange()

				//range定位到obj
				range.moveToElementText(obj)

				//光标移至最后
				range.collapse(false)
				range.select()
			}
		},
		onFileAdded() {

		},
		onSubmitted(fileList) {
			if (fileList.length <= 0) {
				return;
			}
			let index = 0;
			this.allUpLoadIng = true;
			let sizeTotal = 0;
			let totalFileList = [...this.fileList, ...fileList];
			totalFileList.forEach((item) => {
				sizeTotal += +item.size;
			});
			const isLt = sizeTotal / 1024 / 1024 / 10 <= 1;
			if (!isLt) {
				this.allUpLoadIng = false;
				this.isGs = true
				this.msg = "附件大小不得超过10MB"
				this.dialogTipsFolder = true
			} else {
				if (index == fileList.length - 1) {
					this.dealData(index, fileList);
				} else {
					index = index + 1;
					this.dealData(index, fileList);
				}

			}
		},
		dealData(index, fileList) {
			let file = fileList[index]
			let extName = "";
			let AllUpExt = "";
			AllUpExt = ".ofd|.pdf|.txt|.ceb|.sep|.doc|.docx|.xls|.xlsx|.ppt|.pptx|.wps|.ppt|.pptx|.wps|.xml|.dps|.jpg|.jpe|.jpeg|.png|.bmp|.gif|.tif|.tiff|.mp4|.mov|.rm|.rmvb|.avi|.rar|.zip|.7z|";
			extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			if (AllUpExt.indexOf(extName + "|") == "-1") {
				file.cancel();
				this.gsErrorList.push(file);
				fileList.splice(index, 1);
			}
			if (this.gsErrorList.length > 0) {
				this.dialogFolder = true;
			}
			if (fileList.length <= 0) {
				this.allUpLoadIng = false;
				return;
			}
			let list = this.fileList
			this.fileList = [...fileList, ...list];
			if (fileList.length > 0) {
				fileList.forEach((item, index) => {
					item.loading = true
					let fileData = new FormData();
					fileData.append("multipartFile", item.file);
					fileData.append("code ", this.code);
					fileData.append("type ", 1);
					uploadfiles(fileData).then((res) => {
						if (res.code == 0) {
							let obj = {
								loading: false,
								success: true,
								fileId: res.data.fileId,
								name: res.data.fileName,
								size: item.size,
							}
							this.$set(this.fileList, index, obj);
							this.fileIdList.push(obj.fileId)
							this.allUpLoadIng = false;
						}
					}).catch(() => {
						let obj = {
							loading: false,
							error: true,
						}
						this.$set(this.fileList, index, obj);
						this.allUpLoadIng = false;
					})
				})
			}

		},
		submitFolder() {
			this.gsErrorList = [];
			this.dialogFolder = false;
		},
		closedTipsBtn() {
			if (this.isSucess) {
				document.getElementById('content_img').innerHTML = ""
				this.formData.tel = ""
				this.fileIdList = []
				this.fileList = []
			}
			this.dialogTipsFolder = false
			this.isGs = false
			this.msg = ''
			this.isSucess = false
			this.isError = false
			this.isIntenet = false
		},
		submitTipsFolder() {
			if (this.isIntenet) {
				this.saveInfo()
			}
			this.closedTipsBtn()

		},
		submitForm() {
			if(!document.getElementById('content_img').innerHTML)return
			if(this.allUpLoadIng){
				this.$message.closeAll();
				this.$message.error('请等待附件上传完成再提交！')
				return
			}
			if (!this.isSubmit) {
				return
			}
			this.isSubmit = false
			if (!document.getElementById('content_img').innerHTML) {
				this.$message.closeAll();
				this.$message.error('请先填写反馈内容')
				this.isSubmit = true
				return
			}
			let content = document.getElementById('content_img').innerHTML.replace(/<[^>]+>/g, '')
			if (content.length > 300) {
				this.$message.closeAll();
				this.$message.error('最多允许输入300个字符')
				this.isSubmit = true
				return
			}
			this.saveInfo()

		},
		saveInfo() {
			let data = {
				content: this.$refs.content_img.innerHTML,
				contactInformation: this.formData.tel,
				code: this.code,
				fileIdList: this.fileIdList
			}
			saveEnclosureInfo(data).then((res) => {
				if (res.code == 0) {
					this.isSucess = true
					this.msg = "感谢您的反馈，我们将尽快处理。"
					this.dialogTipsFolder = true
				} else if (res.code == 30011) {
					this.isError = true
					this.msg = "每天最多提交十次反馈。"
					this.dialogTipsFolder = true
				} else if (res.code == 30012) {
					this.isError = true
					this.msg = "请从程序入口访问本页面。"
					this.dialogTipsFolder = true
				} else {
					this.isError = true
					this.msg = "请确保您的网络连接正常。"
					this.isIntenet = true
					this.dialogTipsFolder = true
				}
				this.isSubmit = true
			}).catch(() => {
				this.isSubmit = true
				this.isError = true
				this.msg = "请确保您的网络连接正常。"
				this.isIntenet = true
				this.dialogTipsFolder = true
			})
		},
		delBtn(index) {
			this.fileIdList.forEach((item, idx) => {
				if (this.fileList[index].fileId == item) {
					this.fileIdList.splice(idx, 1);
				}
			})
			this.fileList.splice(index, 1);
		}
	}
};
</script>
<style>
.edui-default .edui-editor-bottomContainer td {
	border: none !important;
}
</style>
<style lang="scss" scoped>
.changephone_box {
	.title {
		font-size: 18px;
		font-family: MicrosoftYaHei;
		color: #4F5D79;
		line-height: 22px;
		margin-bottom: 16px;

		img {
			width: 24px;
			margin-right: 16px;
			vertical-align: middle;
		}
	}
}

.index_body {
	background: #F7F9FB;
	min-height: 100%;
}

.feedback_body {
	width: 1200px;
	margin: 0 auto;
	background: #fff;
	padding: 0 13% 46px;

	.feedback_content {
		margin: 32px 0 90px;

		.content_img {
			height: 190px;
			border: 1px solid #E6E9EF;
			padding: 10px;
			overflow-y: auto;
			line-height: 20px;
		}

		.placeholder {
			position: absolute;
			top: 0;
			left: 10px;
			color: #9DA3A8;
			font-size: 14px;
			opacity: .5;
			pointer-events: none;
		}

		.tips_box {
			display: flex;
			justify-content: flex-end;

			.tips_txt {
				font-size: 14px;
				color: #F56C6C;
				flex: 1;
			}

			.num_txt {
				text-align: right;
				width: 100px;
			}
		}

		.tips {
			font-size: 14px;
			color: #9DA3A8;
			line-height: 22px;
			margin-top: 8px;

			span {
				color: #14A8F0;
				cursor: pointer;
			}
		}

		.btn {
			width: 88px;
			height: 32px;
			background: #14A8F0;
			border-radius: 2px;
			border: #14A8F0;
			font-size: 12px;
			color: #FFFFFF;
			line-height: 32px;
		}

		.el-button--primary {

			&:hover,
			&:active,
			&:focus {
				background: #008AD9;
			}
		}
	}

	.btn_box {
		margin-top: 68px;
	}
}

.upload_list {
	margin-top: 8px;
	border: 1px solid #F0F2F6;
	padding: 5px;
	max-height: 100px;
	overflow-y: auto;

	ul li {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 16px;

		&:hover {
			background: rgba(234, 248, 255, 1);
		}

		span.icon {
			width: 24px;
			height: 24px;
			background: url(../../comm/images/document-conversion/feedback/txt_icon.png) 0 0 no-repeat;
			background-size: 100%;
			display: block;
		}

		a {
			flex: 1;
			margin: 0 12px;
			font-size: 12px;
			color: #36425A;
			line-height: 16px;
		}

		.icon_del {
			width: 16px;
			height: 16px;
			background: url(../../comm/images/document-conversion/feedback/icon_del.png) 0 0 no-repeat;
			background-size: 100%;

			&:hover {
				cursor: pointer;
				background: url(../../comm/images/document-conversion/feedback/icon_del_active.png) 0 0 no-repeat;
				background-size: 100%;
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/feedback.vue